import styles from "./TurnNotice.module.css";

interface TurnNoticeProps {
  /** The thread's `turn_notice` (see `AgentThreadRecord.turn_notice`). */
  notice: string | null | undefined;
}

/**
 * Shows the server's note about the turn in progress as a status message, so
 * screen readers announce it. Renders nothing when there is no note.
 */
export function TurnNotice({ notice }: TurnNoticeProps) {
  if (!notice) {
    return null;
  }

  return (
    <p className={styles.turnNotice} role="status">
      {notice}
    </p>
  );
}
